import React__default from 'react';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { NonRxProductCTA } from '../NonRxProductCTA/NonRxProductCTA.js';
import { RxGlassesCTA } from '../RxGlassesCTA/RxGlassesCTA.js';
import { useEcommFacetContext } from '../../context/EcommFacetContext.js';
import { isRxProductAction } from '../../../../types/typeguards.js';
import { useProductData } from '../../../../context/product-context-hooks.js';

const CTA = ({ action , handleConfiguratorOpen , handleConversionEvent , addToCartConfig  })=>{
    const { bookAppointmentRouteConfig , routes  } = useProductData();
    const { getLabel  } = useIntl();
    const { isValid , setNotificationType  } = useEcommFacetContext();
    const triggerAlertMessage = React__default.useCallback(()=>{
        setNotificationType('error');
    }, [
        setNotificationType
    ]);
    /**
   * This is a dummy button that triggers an error message if
   * the add-to-cart flow is not yet valid (i.e. the user still needs to pick a size)
   */ if (!isValid) return /*#__PURE__*/ React__default.createElement(Button, {
        onClick: triggerAlertMessage,
        caption: getLabel('products.actions.addToCart')
    });
    if (isRxProductAction(action)) return /*#__PURE__*/ React__default.createElement(RxGlassesCTA, {
        action: action,
        handleConversionEvent: handleConversionEvent,
        onClickWhenOrderable: handleConfiguratorOpen,
        bookAppointmentRouteConfig: bookAppointmentRouteConfig
    });
    var _stores;
    return /*#__PURE__*/ React__default.createElement(NonRxProductCTA, {
        storesRoute: (_stores = routes.stores) !== null && _stores !== void 0 ? _stores : '',
        action: action,
        handleConversionEvent: handleConversionEvent,
        addToCartConfig: addToCartConfig
    });
};

export { CTA };
//# sourceMappingURL=Cta.js.map
